// まとめ買いページの缶選択UI。
// 追加購入・プレゼント特典はカート内容を基準に perk-fab.js / cart-gift-sync.js が
// 一元管理するため、このファイルは缶の選択とカート追加のみを担当する。
document.addEventListener("DOMContentLoaded", () => {
  const cfg = window.VolumeSelectionConfig || {};
  const itemUnit = cfg.itemUnit || "個";

  // { variantId: qty }
  const selectedItems = {};

  const decreaseBtns = document.querySelectorAll(".btn-decrease");
  const increaseBtns = document.querySelectorAll(".btn-increase");
  // カートエリアのボタン・ステータス参照（スコープ付きクラス名）
  const addBtn = document.querySelector(".vc-btn-add");
  const statusText = document.querySelector(".vc-status .status-text");

  const canCount = () => Object.values(selectedItems).reduce((sum, qty) => sum + qty, 0);

  // 必須商品の初期化
  const mandatoryCards = document.querySelectorAll(
    '.gift-item-card[data-is-mandatory="true"]',
  );
  mandatoryCards.forEach((card) => {
    const variantId = card.getAttribute("data-variant-id");
    selectedItems[variantId] = 1;
  });

  updateStatus();

  // アイテム減少
  decreaseBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      const card = e.target.closest(".gift-item-card");
      const variantId = card.getAttribute("data-variant-id");
      const countEl = card.querySelector(".item-count");
      const isMandatory = card.getAttribute("data-is-mandatory") === "true";
      const minCount = isMandatory ? 1 : 0;

      if (selectedItems[variantId] && selectedItems[variantId] > minCount) {
        selectedItems[variantId]--;
        countEl.textContent = selectedItems[variantId];
        updateStatus();
      }
    });
  });

  // アイテム増加
  increaseBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      const card = e.target.closest(".gift-item-card");
      if (card.classList.contains("sold-out")) return;

      const variantId = card.getAttribute("data-variant-id");
      const countEl = card.querySelector(".item-count");
      const inventoryManagement = card.getAttribute("data-inventory-management");
      const inventoryPolicy = card.getAttribute("data-inventory-policy");
      const inventoryQuantity = parseInt(card.getAttribute("data-inventory-quantity"), 10);
      const currentSelected = selectedItems[variantId] || 0;

      if (
        inventoryManagement === "shopify" &&
        inventoryPolicy !== "continue" &&
        currentSelected >= inventoryQuantity
      ) {
        alert(`在庫が足りないため追加できません（残り${inventoryQuantity}個）`);
        return;
      }

      selectedItems[variantId] = currentSelected + 1;
      countEl.textContent = selectedItems[variantId];
      updateStatus();
    });
  });

  function updateStatus() {
    const tier1 = parseInt(cfg.tier1Qty, 10) || 4;
    const tier2 = parseInt(cfg.tier2Qty, 10) || 7;
    const tier3 = parseInt(cfg.tier3Qty, 10) || 10;
    const cans = canCount();

    const msg0 = cfg.msgTier0 || "";
    const msg1 = cfg.msgTier1 || "";
    const msg2 = cfg.msgTier2 || "";
    const msg3 = cfg.msgTier3 || "";
    const formatDiff = (n) =>
      `<span class="highlight" style="font-size:1.2em;">${n}</span>`;

    const replacePlaceholders = (msg, diffVal = 0) => {
      return msg
        .replace(/\[数量\]/g, cans)
        .replace(/\[X\]/g, cans) // fallback for old settings
        .replace(/\[残り数量\]/g, formatDiff(diffVal))
        .replace(/\[DIFF\]/g, formatDiff(diffVal)) // fallback for old settings
        .replace(/\[単位\]/g, itemUnit);
    };

    if (cans < tier1) {
      statusText.innerHTML = replacePlaceholders(msg0, tier1 - cans);
    } else if (cans < tier2) {
      statusText.innerHTML = replacePlaceholders(msg1, tier2 - cans);
    } else if (cans < tier3) {
      statusText.innerHTML = replacePlaceholders(msg2, tier3 - cans);
    } else {
      statusText.innerHTML = replacePlaceholders(msg3, 0);
    }

    if (addBtn) {
      addBtn.disabled = cans < 1;
      const btnText = cfg.cartBtnText || "カートに追加する";
      addBtn.textContent = `${btnText}（${cans}${itemUnit}）`;
    }
  }

  // カートへ追加ボタン
  if (addBtn) {
    addBtn.addEventListener("click", async () => {
      if (canCount() < 1) return;

      addBtn.disabled = true;
      addBtn.textContent = "追加中...";

      const itemsToCart = [];
      for (const [variantId, quantity] of Object.entries(selectedItems)) {
        if (quantity <= 0) continue;
        itemsToCart.push({
          id: variantId,
          quantity: quantity,
          // _item_type: can はカート側の缶換算（1缶）とプレゼント判定に使われる
          properties: { _item_type: "can" },
        });
      }

      try {
        const response = await fetch(cfg.cartAddUrl + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: itemsToCart }),
        });
        if (!response.ok) {
          const err = await response.json().catch(() => ({}));
          throw new Error(
            err.description ||
              "在庫状況が変わった可能性があります。ページを更新してご確認ください。",
          );
        }
        window.location.href = cfg.cartUrl || "/cart";
      } catch (e) {
        console.error(e);
        alert(e.message || "カートの追加に失敗しました。時間をおいて再試行してください。");
        updateStatus(); // ボタン状態を復元
      }
    });
  }
});
